import { useTranslation } from 'react-i18next';
import AttrLabel from '../Components/AttrLabel';
import AttrField from '../Fields/AttrField';
import ColorField from '../Fields/ColorField';
import { Box } from '@mui/material';
import PixelField from '@SidePanel/Fields/PixelField';

function SpacerPanel() {
    const { t } = useTranslation();

    return (
        <Box padding={3}>
            <AttrLabel>{t('Background Color')}</AttrLabel>
            <AttrField
                Component={ColorField}
                name="style.backgroundColor"
                placeholder={t('Transparent')}
            />
            <AttrLabel>{t('Height')}</AttrLabel>
            <AttrField
                Component={PixelField}
                name="style.height"
                placeholder={t('Height')}
                fallback="24px"
            />
            {/* <AttrLabel>{t('Width')}</AttrLabel>
            <AttrField
                Component={PixelField}
                name="style.width"
                placeholder={t('Full Width')}
            /> */}
        </Box>
    );
}

export default SpacerPanel;
